import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";
import type { HeaderContext } from "@tanstack/react-table";
import { useMemo } from "react";

export const SelectHeader = ({
  table,
  canSelectRow,
  disabled,
  readOnly,
}: HeaderContext<any, unknown> & {
  canSelectRow?: (row: any) => boolean;
  disabled?: boolean;
  readOnly?: boolean;
}) => {
  const handleSelectAll = (checked: boolean) => {
    if (checked && table.getFilteredSelectedRowModel().flatRows.length === 0) {
      const eligibleRows = table
        .getFilteredRowModel()
        .flatRows.filter((row) => !canSelectRow || canSelectRow(row));
      table.toggleAllRowsSelected(false); // First clear selection
      eligibleRows.forEach((row) => row.toggleSelected(true));
    } else {
      table.toggleAllRowsSelected(false);
    }
  };

  const isChecked = useMemo(() => {
    const selectableRows = table
      .getFilteredRowModel()
      .flatRows.filter((row) => !canSelectRow || canSelectRow(row));

    const allSelectableSelected =
      selectableRows.length > 0 &&
      selectableRows.every((row) => row.getIsSelected());

    const someSelectableSelected = selectableRows.some((row) =>
      row.getIsSelected(),
    );

    return allSelectableSelected || (someSelectableSelected && "indeterminate");
  }, [table, canSelectRow, table.getState().rowSelection]);

  return (
    <div className={"flex items-center space-x-2 justify-center"}>
      <Checkbox
        checked={isChecked}
        onCheckedChange={handleSelectAll}
        aria-label="Select all"
        disabled={Boolean(disabled) || Boolean(readOnly)}
        className={cn(
          Boolean(readOnly) && "cursor-not-allowed disabled:opacity-100",
        )}
      />
    </div>
  );
};
